import { render, staticRenderFns } from "./ConsolidarAbastecimentos.vue?vue&type=template&id=bf548426&"
import script from "./ConsolidarAbastecimentos.vue?vue&type=script&lang=js&"
export * from "./ConsolidarAbastecimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports